const o = "magicButton_JfRhm", t = "link_u3EQA", c = "codeError_qCvMq", n = {
  magicButton: o,
  link: t,
  codeError: c
};
export {
  c as codeError,
  n as default,
  t as link,
  o as magicButton
};
//# sourceMappingURL=magicLinkDetection.module.scss.js.map
